import { css } from '@emotion/react';

import theme from 'shared/styles/themes';

export default css({
  '&.elliptical-menu__click-component': {
    alignItems: 'center',
    padding: theme.space[2],
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
});
